import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { ILogSchema } from "../../Schemas/Logs";

interface Filter extends IFilterSchema {
  column: LogListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: LogListColumnSortable;
}

export enum LogListColumnFilterable {
  CAPTION = "caption",
  ACCESS_TOKEN_ID = "access_token_id",
  WORKSPACE_ID = "workspace_id",
  PARTNER_ID = "partner_id",
  USER_ID = "user_id",
  MODEL="model",
  REFERENCE_MODEL="reference_model"
}

export enum LogListColumnSortable {
  CREATED_AT = "created_at",
  ID="id"
}

export interface LogListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}


export interface LogListResponseBody extends IResponseBody {
  data: {
    logs: ILogSchema[];
    total: number;
  };
}

export class LogListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/logs`;
  }

  async send(
    queryStrings?: LogListQueryString
  ): Promise<LogListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
